<template>
  <div class="payContainer">
    <div class="pay-result flexBetweenColumn">
      <div class="success" v-if="status == true">
        <div class="image">
          <img src="../../../assets/images/paySuccess.png" class="successful" />
        </div>
        <div :class="agentShow.status==true?'msg':'msgs'">付款成功</div>
        <div class="btns">
          <div class="btn" @click="clickOrder">查看订单</div>
          <router-link to="/AgentNickName" replace v-if="agentShow.status" style="margin-bottom:8px;">
            <button class="shopping">继续代买</button>
          </router-link>
          <router-link to="/page" replace v-if="agentShow.status">
            <button class="cancelShopping">取消代买</button>
          </router-link>
          <router-link to="/page" replace v-else>
            <button class="shopping">继续购物</button>
          </router-link>

        </div>
      </div>
      <!-- <div class="tips">
        <div class="p">请在 <text class="time">1小时</text> 内完成付款</div>
        <div class="p">否则订单将会被系统取消</div>
        </div>-->
      <div class="error" v-if="status !== true">
        <div class="image">
          <img src="../../../assets/images/payFail.png" class="fail" />
        </div>
        <div :class="agentShow.status==true?'msg':'msgs'">付款失败</div>
        <div class="btns">
          <div class="btn" @click="clickOrder">查看订单</div>
          <router-link to="/AgentNickName" replace v-if="agentShow.status" style="margin-bottom:8px;">
            <button class="shopping">继续代买</button>
          </router-link>
          <router-link to="/page" replace v-if="agentShow.status">
            <button class="cancelShopping">取消代买</button>
          </router-link>
          <router-link to="/page" replace v-else>
            <button class="shopping">继续购物</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      activeText: '继续购物',
      status: false,
      orderId: 0
    };
  },
  computed: {
    ...mapGetters(["agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
  mounted() {
    this.orderNo = this.$route.query.id;
    this.status = this.$route.query.status;
    this.init()


  },
  methods: {
    ...mapActions(["buyAgentStatus"]),
    clickOrder() {
      this.$router.replace({
        name: "orderDetail",
        query: { id: this.orderNo, status: this.status }
      });
    },
    init() {
      if (this.AgentIsShow == true) {
        this.buyAgentStatus({ show: false, type: true })
      }else{
        this.buyAgentStatus({ show: false })
      }
    }
    // payOrder() {
    //   pay.payOrder(this.orderId).then(res => {
    //     this.setData({
    //       status: true
    //     });
    //   });
    // }
  }
};
</script>
<style lang="less" scoped>
.payContainer {
  background-color: #fff;
}

.pay-result {
  padding-top: 23vw;

  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .msg {
      color: #ff526c;
      font-size: 30px;
      margin: 23px 0 100px;
    }
    .msgs{
      color: #ff526c;
      font-size: 30px;
      margin: 23px 0 151px;
    }
  }

  .btns {
    display: flex;
    flex-direction: column;
  }

  .error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .msg {
      color: #999999;
      font-size: 30px;
      margin: 23px 0 100px;
    }
    .msgs{
      color: #ff526c;
      font-size: 30px;
      margin: 23px 0 151px;
    }
  }

  .cancelShopping {
    width: 170px;
    height: 50px;
    border-radius: 25px;
    background-color: #FFF;
    border: 1px solid rgba(255, 82, 108, 1);
    color: rgba(255, 82, 108, 1);
  }

  .image {
    width: 189px;
    height: 140px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .btn {
    text-align: center;
    color: #989898;
    margin-bottom: 16px;
  }

}
</style>